/** Query keys that show the people load and the computed capacity of the schedule. Moving a booking changes them, and so does
 *  the Undo of that move. The keys are prefixes: `["schedule", "capacity"]` matches every week window that
 *  `useComputedCapacity` caches. `["list", "people"]` is what `keys.list("people")` builds in hooks.ts; it is written out
 *  here so this file imports nothing and its test loads no UI code. */
export function capacityKeysFor(collection: string): readonly (readonly string[])[] {
  return collection === "allocations" ? [["list", "people"], ["schedule", "capacity"]] : [];
}
